import Alpine from 'alpinejs'

export default () => {

    window.Alpine = Alpine

    Alpine.start()
};